import { hotjar } from 'react-hotjar';

if (process.env.REACT_APP_HOTJAR_HJID && process.env.REACT_APP_HOTJAR_HJSV) {
  hotjar.initialize(process.env.REACT_APP_HOTJAR_HJID as unknown as number, process.env.REACT_APP_HOTJAR_HJSV as unknown as number);
}
